import { Component, AfterViewInit, Input, ElementRef, EventEmitter, Output } from '@angular/core';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';

@Component({
  selector: 'adminapp-asset-summary-table',
  templateUrl: './asset-summary.component.html',
  styleUrls: ['./asset-summary.component.scss']
})
export class AssetSummaryComponent implements AfterViewInit {

  shouldDisplayError: boolean;

  @Input()
  set data(entries: any) {
    const grid = this.elRef.nativeElement.querySelector('coretex-grid');
    if (!entries || entries.length === 0) {
      this.shouldDisplayError = false;
      return;
    }
    this.shouldDisplayError = true;
    grid.columns = [
      { id: 'key', label: 'Asset Types (' + entries.length + ')', isSortable: true, isResizable: true },
      { id: 'value', label: 'Confirmed Equipment (' + this.getTotalEntries(entries) + ')', isSortable: true, isResizable: true }];
    grid.items = entries;
  }

  @Output()
  assetSelectedEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elRef: ElementRef) { }

  ngAfterViewInit(): void {
    window['assetLinkClicked'] = this.onAssetClick.bind(this);
  }

  getTotalEntries(data: Array<SummaryTableEntry>) {
    let total = 0;
    data.forEach((entry) => {
      total += entry.value;
    });
    return total;
  }

  onAssetClick(event) {
    this.assetSelectedEventEmitter.emit({assetIri: event.id});
  }
}
